"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authLoading = void 0;
const generated_1 = require("../../graphql/generated");
const authLoading = (context) => (callback) => {
    const snapAuthUpdatedEvent = new CustomEvent("SNAP_AUTH_UPDATED", {
        detail: "authLoading",
    });
    window.dispatchEvent(snapAuthUpdatedEvent);
    if (!context.apolloClient) {
        console.error("No Apollo Client Available");
        callback({ type: "authFailedEvent" });
        return;
    }
    context.apolloClient
        .query({ query: generated_1.GetBasicUserDataDocument, errorPolicy: 'ignore' })
        .then(() => {
        callback({ type: "authLoadingSuccessEvent" });
    });
};
exports.authLoading = authLoading;
